import {
    calculateCurrentArticleBeingScrolled,
    getProgressTimer,
    getUrlAccessKey,
    getUrlGroupingId,
    getUrlTemporaryId,
    getUrlDate,
    getIsNavBarOpen,
} from "../selectors/navigation";
import {push} from "connected-react-router";
import copy from 'copy-to-clipboard';
import {getArticleTitleRaw} from "../selectors/articles";
import {getFormattedArchiveLink} from "../../util/format";
import {getTopHeaderOffset, isMobile} from "../../util/screen"
import { animateScroll, scroller } from "react-scroll";


// Toggle the nav bar on/off (only matters on mobile)
// If value is passed, it will be forced
export const navBarToggle = (isOpen = null) => (dispatch, getState) => {
    const state = getState();

    const navBarOpen = (isOpen !== null) ? isOpen : !getIsNavBarOpen(state);

    if (isMobile()) {
        const body = document.body;

        const className = navBarOpen ? "mobileNavOpen" : "";

        body.className = className;
    }

    dispatch({
        type: "navigation/NAV_BAR_TOGGLE",
        payload: navBarOpen,
    });
};


/**
 * Called when the page loads - stores the props provided by react router
 * @param params (match params)
 * @param hash
 * @returns {{payload: *, type: string}}
 */
export const pageLoaded = (params, hash) => ({
    type: 'navigation/PAGE_LOADED',
    payload: {
        params: params,
        initialHash: hash
    }
});

/**
 * Navigate to a newsletter edition (
 * @param {string} date - the date in the URL format
 * @param {string} [groupingId] - Optional - will default to using the one in the state
 * @param {string} [hash] - Optional (without the #) - will default to no hash parameter
 * @returns {Function}
 */
export const navigateToNewsletterEdition = ({url, hash, date, groupingId}) => (dispatch, getState) => {
    if (url) {
        //url already formatted for us! lets go there! yay!
        if (hash) {
            scroller.scrollTo(hash, { smooth: true, offset: -1 * getTopHeaderOffset() });
        } else {
            animateScroll.scrollToTop();
        }

        dispatch(push(url));
    } else {
        const state = getState();

        const accessKey = getUrlAccessKey(state);

        // If we don't pass a groupingId default to the one in the state
        const gId = groupingId || getUrlGroupingId(state);

        // If we don't pass a date default to the one in the state
        const d = date || getUrlDate(state);

        const newsletterTempId = getUrlTemporaryId(state);

        const hashPortion = hash ? `#${hash}` : null;

        const url = getFormattedArchiveLink(accessKey, gId, d, hashPortion, newsletterTempId);

        if (hash) {
            scroller.scrollTo(hash);
        } else {
            animateScroll.scrollToTop();
        }

        if (url) {
            dispatch(push(url));
        }
    }

    dispatch(navBarToggle());
};

/**
 * Start the timer that will gradually update the progress tracker
 * @returns {{type: string}}
 */
export const startProgressTracker = () => (dispatch, getState) => {
    let timer = getProgressTimer(getState());

    if(!timer){
        timer = setInterval(() => {
            dispatch(updateScrollingStats());
        }, 200)

        dispatch({
            type: 'navigation/START_PROGRESS_TRACKER',
            payload: timer
        })
    }
};

/**
 * Start the timer that will gradually update the progress tracker
 * @returns {{type: string}}
 */
export const updateScrollingStats = () => (dispatch, getState) => {
    const state = getState();
    const article = calculateCurrentArticleBeingScrolled(state);
    const {id, top, height, fitsInScreen} = article;
    const title = getArticleTitleRaw(state, id);
    const tm = getTopHeaderOffset();
    const percentage = fitsInScreen ? 0 : ((top - tm)*(100/( -1* height)) || 0);

    const action ={
        type: 'navigation/UPDATE_SCROLLING_STATS',
        payload: {
            currentArticle: article,
            percentage: percentage,
            tm: tm
        }
   };
    dispatch(action);
};

/**
 * Copy something to the clipboard
 * @param {string} thingToCopy
 * @returns {{type: string}}
 */
export const copyToClipboard = (thingToCopy)  => (dispatch, getState) => {
    // actual copy here
    copy(thingToCopy);

    // set timeout to remove the animation class
    setTimeout(() => {
        dispatch(copyToClipboardDone())
    }, 3000);

    // Fire the copy event
    dispatch({
        type: 'navigation/COPY_TO_CLIPBOARD',
        payload: {
            thingToCopy
        }
    });
};

/**
 * Done copying something to the clipboard (to remove notification)
 * @param {string} thingToCopy
 * @returns {{type: string}}
 */
export const copyToClipboardDone = () => {
    return {
        type: 'navigation/COPY_TO_CLIPBOARD_DONE'
    }
};

/**
 * Toggle the sharing menu
 * @returns {{type: string}}
 */
export const toggleSharingMenu = () => ({
    type: 'navigation/TOGGLE_SHARING_MENU'
});

/**
 * Open the sharing menu
 * @returns {{type: string}}
 */
export const openSharingMenu = () => ({
    type: 'navigation/OPEN_SHARING_MENU'
});

/**
 * Close the sharing menu
 * @returns {{type: string}}
 */
export const closeSharingMenu = () => ({
    type: 'navigation/CLOSE_SHARING_MENU'
});

/**
 * Action fired to start downloading a PDF
 * @returns {{type: string}}
 */
export const startDownloadingPdf = () => ({
    type: 'navigation/PDF_START_DOWNLOAD'
});

/**
 * Action fired to stop downloading a PDF
 * @returns {{type: string}}
 */
export const stopDownloadingPdf = () => ({
    type: 'navigation/PDF_STOP_DOWNLOAD'
});
